<template>
    <div>
        <div class="form-group">
            <label>{{translate('ozne.tuzelSahis.name')}}</label>
            <input v-model="value.Ad" type="text" class="form-control" required />
        </div>
        <div class="form-group">
            <label>{{translate('ozne.tuzelSahis.mersisNo')}}</label>
            <input v-model="value.MersisNo" @input="updateValue" type="number" minlength="16" maxlength="16" class="form-control" required />
        </div>
    </div>
</template>

<script>
export default {
    components: {

    },
    props: ['value'],
    data(){
        return {
mersisNumber:''
        }
    },
    methods: {
   updateValue(event) {
      const value = event.target.value
      if (String(value).length <= 16) {
          this.mersisNumber = value;
      }
      this.value.MersisNo = this.mersisNumber;
      this.$forceUpdate()
    }
    }
}

</script>
